
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import Dots from './Dots.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    NewSwiper,
    Dots,
    LazyImg
  }
})
export default class StationeryAddress extends Vue {
  dataSource: any[] = [
    this.$images.stationery_address_swiper_01,
    this.$images.stationery_address_swiper_02,
    this.$images.stationery_address_swiper_03,
    this.$images.stationery_address_swiper_04,
    this.$images.stationery_address_swiper_05
  ]

  activeIndex: number = 0
  autoplayDuration: number = 3000

  @Ref()
  swiper: {
    dotScrollTo: (index: number) => void
  }

  // 指示点滚动事件
  handleScrollTo(index: number) {
    if (!this.swiper) return
    this.swiper.dotScrollTo(index)
  }

  // 轮播切换事件
  handleChange(index: number) {
    if (this.activeIndex === index) return

    this.activeIndex = index
  }

  @Emit('open-modal')
  handleOpenModal() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
